import React from 'react'
import styled from 'styled-components'
import { DesktopMode, MobileMode } from 'layout/ResponsiveMedia'

const HeaderWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: clamp(0.5rem, 2vw, 1rem) 0;
`

const Title = styled.h1`
    flex: 1;
    text-align: center;
    margin: 0;
    color: #2c3e50;
    font-weight: 700;
    font-size: clamp(1.25rem, 2.5vw, 2.5rem);
`

const ActionBtn = styled.button`
    background: #2f2ccf;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 0.5rem 0.875rem;
    font-weight: 600;
    cursor: pointer;
`

const Logo = styled.img`
    height: clamp(40px, 8vw, 100px);
    width: auto;
    object-fit: contain;
    display: block;
    margin: 0 auto clamp(0.25rem, 1vw, 0.5rem);
`

export const DashboardHeader = ({ title, onBack, onHome, showBack = false, showHome = false }) => {
    return (
        <div>
            <DesktopMode>
                <Logo src="/images/franchising-xpert.png" alt="Franchising Xpert" />
            </DesktopMode>
            <MobileMode>
                <Logo src="/images/franchising-xpert.png" alt="Franchising Xpert" />
            </MobileMode>
            <HeaderWrap>
                <div style={{ minWidth: 120 }}>
                    {showBack && (
                        <ActionBtn type="button" onClick={onBack}>
                            ← Back
                        </ActionBtn>
                    )}
                </div>
                <Title>{title}</Title>
                <div style={{ minWidth: 120, textAlign: 'right' }}>
                    {showHome && (
                        <ActionBtn type="button" onClick={onHome}>
                            🏠 Home
                        </ActionBtn>
                    )}
                </div>
            </HeaderWrap>
        </div>
    )
}

export default DashboardHeader
